import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import microsoftLogo from "../../assets/Login/microsoft.svg";
import styles from "../../styles/login/login.module.css";
import { api, post } from "../../utils/api";
import "../../Pages/Login/login.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import companyLogo from "../../assets/images/nirantara_logo_new.svg";
import vajraPoweredByLogo from "../../assets/images/vajra_powered_by_logo.svg";
import { getSubdomainLabel } from "../../utils/consultantDomain";

const MicrosoftRedirect = ({ onBack, initialEmail = "" }) => {
  const [searchParams] = useSearchParams();
  const [ssoEmail, setSsoEmail] = useState("");
  const [redirecting, setRedirecting] = useState(false);

  useEffect(() => {
    const emailParam = searchParams.get("email") || initialEmail;
    if (emailParam) {
      setSsoEmail(emailParam);
    }
  }, [searchParams, initialEmail]);

  const handleSsoLogin = async () => {
    try {
      if (!ssoEmail) {
        alert("Please enter your email");
        return;
      }

      if (!ssoEmail.includes("@")) {
        alert("Enter a valid email");
        return;
      }

      const res = await post(`${api}/api/auth/sso/init`, { email: ssoEmail });
      const redirectUrl = res?.data?.redirectUrl;

      if (!redirectUrl) {
        throw new Error("No redirect URL received");
      }

      setRedirecting(true);
      await new Promise((resolve) => setTimeout(resolve, 1000));

      window.location.href = `${api}${redirectUrl}`;
    } catch (err) {
      console.error("SSO init failed:", err);
      setRedirecting(false);
      alert(err?.response?.data?.message || "SSO not available for this email");
    }
  };

  if (redirecting) {
    return (
      <div className={styles.redirect_container}>
        <Box>
          <img
            src={microsoftLogo}
            alt="Microsoft Logo"
            className={styles.microsoft_logo}
          />
        </Box>
        <Box className={styles.redirect_content}>
          <CircularProgress className={styles.circular_progress} />
          <p className={styles.redirect_heading}>Redirecting to Microsoft...</p>
          <p className={styles.redirect_subheading}>
            You are being securely redirected <br /> to sign with your Microsoft{" "}
            <br />
            account.
          </p>
        </Box>
      </div>
    );
  }

  return (
    <div className="login-sso-container">
      <p
        className="login-sso-back-to-sign-in"
        onClick={onBack}
        style={{ cursor: "pointer" }}
      >
        <ArrowBackIcon />
        Back to Sign in
      </p>
      <p className="login-sso-heading">Sign in with Microsoft</p>
      <p className="login-sso-subheading">
        Enter your work email to sign in with Microsoft.
      </p>

      <div className="social-logo-div">
        <img
          src={microsoftLogo}
          alt="Microsoft Logo"
          className="social-login-logo"
        />
        <div className="social-text">Microsoft 365</div>
      </div>
      <p className="input-label">Work Email</p>
      <input
        placeholder="Enter work email"
        value={ssoEmail}
        onChange={(e) => setSsoEmail(e.target.value)}
        className="sso-email-input"
      />
      <div
        className="microsoft-sso-button"
        onClick={handleSsoLogin}
        style={{ cursor: "pointer" }}
      >
        Continue with Microsoft
      </div>

      <Typography
        variant="body2"
        color="textSecondary"
        sx={{
          position: "absolute",
          bottom: "20px",
          left: 0,
          right: 0,
          textAlign: "center",
          color: "#838383",
          fontSize: "11px",
          ml: 0,
        }}
      >
        Powered by
        <span style={{ marginLeft: "0.25rem" }}>
          <img
            src={getSubdomainLabel() ? vajraPoweredByLogo : companyLogo}
            alt="Company Logo"
            style={{
              height: "32px",
              display: "inline-block",
              marginTop: "-5px",
            }}
          />
        </span>
      </Typography>
    </div>
  );
};

export default MicrosoftRedirect;
